export const parseBulkText = (rawText = "") => {
  return rawText
    .split(/\r?\n/)
    .map(l => l.trim())
    .filter(Boolean)
    .map(line => {
      const parts = line.split(/[\t,;|]+|\s+/).filter(Boolean);

      const code = parts[0];
      let qty = 1;

      if (parts[1] && !isNaN(parts[1])) {
        qty = Math.max(1, parseInt(parts[1], 10));
      }

      return { code, qty };
    });
};
